import { render, staticRenderFns } from "./OsCampaignForm.vue?vue&type=template&id=7fb45830&scoped=true"
import script from "./OsCampaignForm.vue?vue&type=script&lang=ts"
export * from "./OsCampaignForm.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fb45830",
  null
  
)

export default component.exports